/**
 * ArloSEO mascot — a tiny chibi otter face.
 *
 * Designed as a single inline SVG so it tints with `currentColor`
 * and renders crisply from 14px (favicon) up to hero size. The face
 * is a stack of circles + an ellipse nose — simple, readable, and on
 * brand with the brutalist-meets-friendly aesthetic.
 */
export default function OtterIcon({ size = 24, className = "", title = "Arlo the otter" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      {/* Ears */}
      <circle cx="8.5" cy="10.5" r="3.2" fill="currentColor" />
      <circle cx="23.5" cy="10.5" r="3.2" fill="currentColor" />
      {/* Head */}
      <circle cx="16" cy="17" r="9" fill="currentColor" />
      {/* Eyes — negative space (uses parent bg via white) */}
      <circle cx="12.7" cy="15.5" r="1.15" fill="#ffffff" />
      <circle cx="19.3" cy="15.5" r="1.15" fill="#ffffff" />
      {/* Nose / muzzle */}
      <ellipse cx="16" cy="19.6" rx="1.9" ry="1.25" fill="#ffffff" />
      {/* Smile */}
      <path
        d="M14.3 21.1 Q16 22.2 17.7 21.1"
        stroke="#ffffff"
        strokeWidth="0.9"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
